export const OPEN_PIN_PRODUCT_MODAL = 'OPEN_PIN_PRODUCT_MODAL';
export const SET_INITIAL_SCROLLER_HEIGHT = 'SET_INITIAL_SCROLLER_HEIGHT';
export const UPDATE_SCROLLER_HEIGHT = 'UPDATE_SCROLLER_HEIGHT';
export const GTL_OPEN_FILTERS_MODAL = 'GTL_OPEN_FILTERS_MODAL';
export const ADD_PREFERENCES = 'ADD_PREFERENCES';
export const OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL';
export const PIN_IMAGE_FOR_REQUEST = 'PIN_IMAGE_FOR_REQUEST';
export const OPEN_REGISTERED_MODAL = 'OPEN_REGISTERED_MODAL';
export const GTL_RELOAD = 'GTL_RELOAD';
